module.exports = __webpack_public_path__ + "img/motor_no34.8d392047.jpg";